import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ElectricityDisconnectionPage, ElectricityDisconnectionPageProps } from "./ElectricityDisconnectionPage";

export const EMPTY_PAGE_CONTENT: ElectricityDisconnectionPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/disconnections";

export const ElectricityDisconnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ElectricityDisconnectionPageProps>("electricity_disconnections", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ElectricityDisconnectionPage {...routeProps} {...content} />;
};
